import { createContext, useState, useEffect } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    const userName = localStorage.getItem("userName");
    const role = localStorage.getItem("role");

    if (token) {
      setAuth({ accessToken: token, role, userName });
    } else {
      setAuth({});
    }

    setLoading(false);
  }, []);

  return (
    <AuthContext.Provider value={{ auth, setAuth, loading  }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
